import type { RadioMessage } from './comms';

export interface ScheduledRadio { message: RadioMessage; aircraftId?: number; startsAtS: number; endsAtS: number; priority?: boolean }
/** One simulated frequency. Audio playback renders these deliveries; it does not own the clock. */
export function createRadioChannel() {
  let freeAtS = 0;
  let transmittingUntilS = 0;
  const queue: ScheduledRadio[] = [];
  return {
    enqueue(message: RadioMessage, aircraftId?: number, priority = false) {
      const durationS = Math.min(8, Math.max(1, message.speech.split(/\s+/).length / 3.5));
      const startsAtS = priority ? Math.max(message.timeS, transmittingUntilS, ...queue.filter((q) => q.priority).map((q) => q.endsAtS)) : Math.max(message.timeS, freeAtS);
      const endsAtS = startsAtS + durationS;
      if (priority) for (const q of queue) if (q.startsAtS >= startsAtS) { q.startsAtS += durationS; q.endsAtS += durationS; }
      queue.push({ message, aircraftId, startsAtS, endsAtS, priority });
      queue.sort((a, b) => a.startsAtS - b.startsAtS);
      freeAtS = Math.max(endsAtS, ...queue.map((q) => q.endsAtS));
      return { startsAtS, endsAtS, shiftedByS: priority ? durationS : 0 };
    },
    deliver(nowS: number, deliver: (entry: ScheduledRadio) => void) {
      while (queue[0] && queue[0].startsAtS <= nowS) { const next = queue.shift()!; transmittingUntilS = next.endsAtS; deliver(next); }
    },
    get freeAtS() { return freeAtS; },
    snapshot() { return structuredClone({ freeAtS, transmittingUntilS, queue }); },
    restore(state: { freeAtS: number; transmittingUntilS: number; queue: ScheduledRadio[] }) { freeAtS = state.freeAtS; transmittingUntilS = state.transmittingUntilS; queue.splice(0, queue.length, ...state.queue); },
  };
}
